// ============================================================
// 🏪 商店 / 背包 / 装备系统 — 从 dnf.html 提取
// ============================================================

import { S, save, renderStatusbar } from '../state.js';
import { toast, showDropNotify, getItemIcon } from '../utils.js';
import { CLASSES } from '../data/classes.js';
import { EQUIPMENT_DB, TIERS, CONSUMABLES, ENHANCE_TABLE, JARS, getEquipById } from '../data/equipment.js';
import { NPCS, REGIONS } from '../data/world.js';
import { ITEM_ICONS, getEquipStats, isWeaponMismatch, getAtkEffectDesc } from '../utils.js';
import { sfxCoin, sfxJarOpen, playSFX, sfxNPCSpeak } from '../audio.js';

// --- 直接购买 ---
export function buyItemDirect(itemId, price, qty) {
  if(S.gold < price) { toast('金币不足！'); return false; }
  const it = CONSUMABLES[itemId];
  if(!it) return false;
  let placed = false;
  for(let i=0; i<S.inventory.length; i++) {
    if(S.inventory[i] && S.inventory[i].id === itemId && (S.inventory[i].qty||1) < 99) {
      S.inventory[i].qty = (S.inventory[i].qty||1) + qty;
      placed = true; break;
    }
  }
  if(!placed) {
    if(S.inventory.length >= 128) { toast('背包已满！'); return false; }
    S.inventory.push({ id: itemId, type:'consumable', qty: qty });
  }
  S.gold -= price;
  toast(`购买了【${it.name}】x${qty}`);
  save();
  return true;
}

// --- 赛丽亚的商店 ---
export function renderSeraShop() {
  const main = document.getElementById('main');
  const items = [
    { id:'hp_potion_s', name:'初级HP药剂', price:5, desc:'恢复40HP', icon:'🧪' },
    { id:'hp_potion_m', name:'中级HP药剂', price:15, desc:'恢复100HP', icon:'🧪' },
    { id:'hp_potion_l', name:'高级HP药剂', price:40, desc:'恢复250HP', icon:'🧪' },
    { id:'mp_potion_s', name:'技能药剂', price:8, desc:'恢复30MP', icon:'💠' },
    { id:'antidote',    name:'解毒药',   price:12, desc:'治疗中毒', icon:'🌿' },
  ];
  let html = `<div class="shop-container">
    <div class="shop-header">
      <span>💊 赛丽亚的商店</span>
      <span style="color:var(--gold);font-size:12px;">💰 ${S.gold}G</span>
    </div>
    <div class="shop-npc-desc">「${NPCS.sera.desc}」</div>
    <div class="shop-grid">`;
  items.forEach(it => {
    html += `<div class="shop-item" onclick="buyItemDirect('${it.id}',${it.price},1)">
      <span class="shop-item-icon">${it.icon}</span>
      <div class="shop-item-info">
        <div class="shop-item-name">${it.name}</div>
        <div class="shop-item-desc">${it.desc}</div>
      </div>
      <span class="shop-item-price">${it.price}G</span>
    </div>`;
  });
  // 疲劳药（调试用）
  html += `<div class="shop-item" onclick="buyFatiguePotion()">
    <span class="shop-item-icon">⚡</span>
    <div class="shop-item-info">
      <div class="shop-item-name" style="color:var(--gold);">疲劳恢复药</div>
      <div class="shop-item-desc">恢复30点疲劳值</div>
    </div>
    <span class="shop-item-price" style="color:var(--gold);">1G</span>
  </div>`;
  html += `</div>`;

  // 出售消耗品
  const consumableItems = [];
  S.inventory.forEach((inv, idx) => {
    if(inv && inv.type !== 'equip' && CONSUMABLES[inv.id]) {
      consumableItems.push({ idx, con: CONSUMABLES[inv.id] });
    }
  });
  if(consumableItems.length > 0) {
    html += `<div class="progress-title" style="margin:12px 0 6px;">💰 出售药剂</div><div class="shop-grid">`;
    consumableItems.forEach(ci => {
      const sp = Math.floor(ci.con.price * 0.5);
      html += `<div class="shop-item" onclick="doSellConsumable(${ci.idx})">
        <span class="shop-item-icon">${ci.con.name.includes('HP')?'🧪':'💠'}</span>
        <div class="shop-item-info"><div class="shop-item-name">${ci.con.name}</div></div>
        <span class="shop-item-price" style="color:var(--gold);">卖 +${sp}G</span>
      </div>`;
    });
    html += `</div>`;
  }

  html += `<button class="continue-btn" onclick="backToRegion()">← 返回城镇</button>
          <button class="continue-btn" onclick="goHome()" style="margin-top:4px;font-size:11px;">🏠 返回大厅</button></div>`;
  main.innerHTML = html;
}

// --- 疲劳恢复 ---
export function buyFatiguePotion() {
  if(S.gold < 1) { toast('金币不足！'); return; }
  S.gold -= 1;
  S.fatigue = Math.min(S.maxFatigue||156, (S.fatigue||0) + 30);
  toast('恢复了30点疲劳值！⚡');
  save(); renderSeraShop();
}

// --- 罐子商人 ---
export function renderJarShop() {
  const main = document.getElementById('main');
  let html = `<div class="shop-container">
    <div class="shop-header">
      <span>🏺 金罐的袖珍罐商店</span>
      <span style="color:var(--gold);font-size:12px;">💰 ${S.gold}G</span>
    </div>
    <div class="shop-npc-desc">「${NPCS.jarmerchant.desc}」</div>
    <div class="shop-grid">`;
  JARS.forEach(j => {
    html += `<div class="shop-item jar-item" onclick="openJar('${j.id}')">
      <span class="shop-item-icon" style="font-size:28px;">${j.icon}</span>
      <div class="shop-item-info">
        <div class="shop-item-name">${j.name}</div>
        <div class="shop-item-desc">${j.desc}</div>
      </div>
      <span class="shop-item-price">${j.price}G</span>
    </div>`;
  });
  html += `</div>
    <div id="jarResult" style="text-align:center;padding:10px;min-height:40px;"></div>
    <button class="continue-btn" onclick="backToRegion()">← 返回城镇</button>
          <button class="continue-btn" onclick="goHome()" style="margin-top:4px;font-size:11px;">🏠 返回大厅</button>
  </div>`;
  main.innerHTML = html;
}

// --- 铁匠林纳斯 ---
export function renderBlacksmithShop() {
  if(!S.enhanceLevels) S.enhanceLevels = {};
  const main = document.getElementById('main');
  const hasEquip = S.equipment && Object.keys(S.equipment).length > 0;
  let html = `<div class="shop-container">
    <div class="shop-header">
      <span>🔨 铁匠林纳斯</span>
      <span style="color:var(--gold);font-size:12px;">💰 ${S.gold}G</span>
    </div>
    <div class="shop-npc-desc">「${NPCS.blacksmith.desc}」</div>`;

  // 强化区域
  html += `<div class="progress-title" style="margin:16px 0 8px;">⚡ 装备强化</div>`;
  if(hasEquip) {
    html += `<div class="enhance-list">`;
    for(const slot in S.equipment) {
      const item = getEquipById(S.equipment[slot]);
      if(!item) continue;
      const lv = S.enhanceLevels[S.equipment[slot]] || 0;
      const tierInfo = TIERS[item.tier];
      const nextLv = lv + 1;
      const eData = ENHANCE_TABLE.find(e => e.lv === nextLv);
      const adminCfg = window.__adminCfg || {};
      const adminRate = adminCfg.enhanceRates ? adminCfg.enhanceRates[nextLv - 1] : undefined;
      const displayRate = (adminRate !== undefined) ? adminRate : eData.rate;
      const canEnhance = eData && nextLv <= 10;
      html += `<div class="enhance-item">
        <span style="color:${tierInfo.color};flex:1;">
          ${getItemIcon(item)} ${item.name}
          ${lv > 0 ? `<span style="color:var(--gold);font-size:10px;">+${lv}</span>` : ''}
        </span>
        ${canEnhance ? `<button class="enhance-btn" onclick="doEnhance('${S.equipment[slot]}')">
          强化+${nextLv} (${eData.cost}G · ${Math.round(displayRate*100)}%)
        </button>` : `<span style="color:var(--gold);font-size:11px;">MAX +10</span>`}
      </div>`;
    }
    html += `</div>`;
  } else {
    html += `<div style="color:var(--dim);text-align:center;padding:10px;">还没有装备可以强化</div>`;
  }

  // 分解区域
  html += `<div class="progress-title" style="margin:16px 0 8px;">♻️ 装备分解</div>`;
  const dismantleItems = [];
  if(S.equipment) {
    for(const slot in S.equipment) {
      const item = getEquipById(S.equipment[slot]);
      if(item) dismantleItems.push({ id:S.equipment[slot], item, slot, source:'equipped' });
    }
  }
  S.inventory.forEach((inv, idx) => {
    if(inv && inv.type === 'equip') {
      const item = getEquipById(inv.id);
      if(item) dismantleItems.push({ id:inv.id, item, idx, source:'inventory' });
    }
  });
  if(dismantleItems.length > 0) {
    html += `<div class="enhance-list">`;
    dismantleItems.forEach(di => {
      const tierInfo = TIERS[di.item.tier];
      const enhanceLv = S.enhanceLevels[di.id] || 0;
      const dismantleGold = getDismantleGold(di.item.tier, enhanceLv);
      html += `<div class="enhance-item">
        <span style="color:${tierInfo.color};flex:1;">${getItemIcon(di.item)} ${di.item.name} ${enhanceLv>0?`+${enhanceLv}`:''}</span>
        <button class="enhance-btn" style="border-color:var(--red)44;color:var(--red);" onclick="dismantleEquip('${di.id}','${di.source}',${di.source==='inventory'?di.idx:"'"+di.slot+"'"})">
          分解 +${dismantleGold}G
        </button>
      </div>`;
    });
    html += `</div>`;
  } else {
    html += `<div style="color:var(--dim);text-align:center;padding:10px;">没有可分解的装备</div>`;
  }

  // 出售区域 - 只出售背包中未装备的物品
  html += `<div class="progress-title" style="margin:16px 0 8px;">💰 装备出售</div>`;
  const sellItems = [];
  S.inventory.forEach((inv, idx) => {
    if(inv && inv.type === 'equip') {
      const item = getEquipById(inv.id);
      if(item) sellItems.push({ id:inv.id, item, idx });
    }
  });
  if(sellItems.length > 0) {
    html += `<div class="enhance-list">`;
    sellItems.forEach(si => {
      const ti = TIERS[si.item.tier];
      const price = getSellPrice(si.item);
      html += `<div class="enhance-item">
        <span style="color:${ti.color};flex:1;">${getItemIcon(si.item)} ${si.item.name} Lv.${si.item.lv}</span>
        <button class="enhance-btn" style="border-color:var(--gold)44;color:var(--gold);" onclick="doSellEquip('${si.id}','inventory',${si.idx})">
          出售 +${price}G
        </button>
      </div>`;
    });
    html += `</div>`;
  } else {
    html += `<div style="color:var(--dim);text-align:center;padding:10px;">背包中没有可出售的装备</div>`;
  }

  html += `<button class="continue-btn" onclick="backToRegion()">← 返回城镇</button>
          <button class="continue-btn" onclick="goHome()" style="margin-top:4px;font-size:11px;">🏠 返回大厅</button></div>`;
  main.innerHTML = html;
}

// --- 装备分解 ---
export function dismantleEquip(equipId, source, identifier) {
  const item = getEquipById(equipId);
  if(!item) return;

  // 罕见及以上装备才弹确认，且支持"24小时不再提醒"
  const needConfirm = item.tier === 'unique' || item.tier === 'epic';
  if(needConfirm) {
    const skipUntil = parseInt(localStorage.getItem('dnf_skip_dismantle_warn')||'0');
    if(Date.now() < skipUntil) { window.doDismantle(item, equipId, source, identifier); return; }
    window.showDismantleConfirm(item, equipId, source, identifier);
    return;
  }
  doDismantle(item, equipId, source, identifier);
}

// --- 凯丽的强化铺 ---
export function renderKiriShop() {
  if(!S.enhanceLevels) S.enhanceLevels = {};
  const main = document.getElementById('main');
  let html = `<div class="shop-container">
    <div class="shop-header"><span>⚡ 凯丽的强化铺</span><span style="color:var(--gold);font-size:12px;">💰 ${S.gold}G</span></div>
    <div class="shop-npc-desc">「${NPCS.kiri.desc}」</div>
    <div class="progress-title" style="margin:12px 0 8px;">⚡ 高级强化（上限+15，失败可能碎装备）</div>`;
  
  const equipped = [];
  if(S.equipment) for(const slot in S.equipment) {
    const item = getEquipById(S.equipment[slot]);
    if(item) equipped.push({ id:S.equipment[slot], item, slot });
  }
  if(equipped.length > 0) {
    html += `<div class="enhance-list">`;
    equipped.forEach(eq => {
      const lv = S.enhanceLevels[eq.id] || 0;
      const ti = TIERS[eq.item.tier];
      const nextLv = lv + 1;
      const canEn = nextLv <= 15;
      const cost = 500 + nextLv * 300;
      const rate = Math.max(0.1, 1.0 - (nextLv - 1) * 0.08);
      html += `<div class="enhance-item">
        <span style="color:${ti.color};flex:1;">${getItemIcon(eq.item)} ${eq.item.name} ${lv>0?`<span style="color:var(--gold);">+${lv}</span>`:''}</span>
        ${canEn ? `<button class="enhance-btn" style="border-color:var(--pink)44;color:var(--pink);" onclick="doKiriEnhance('${eq.id}',${nextLv})">
          +${nextLv} [${cost}G · ${Math.round(rate*100)}%]</button>` : `<span style="color:var(--gold);">MAX +15</span>`}
      </div>`;
    });
    html += `</div>`;
  } else { html += `<div style="color:var(--dim);text-align:center;padding:10px;">没有装备</div>`; }
  
  html += `<button class="continue-btn" onclick="backToRegion()">← 返回城镇</button>
          <button class="continue-btn" onclick="goHome()" style="margin-top:4px;font-size:11px;">🏠 返回大厅</button></div>`;
  main.innerHTML = html;
}

// --- 歌兰蒂斯·首饰商店 ---
export function renderGrandisShop() {
  const main = document.getElementById('main');
  const accSlots = ['ring','amulet','bracelet'];
  const owned = new Set();
  S.inventory.forEach(i => { if(i && i.type==='equip') owned.add(i.id); });
  if(S.equipment) for(const s in S.equipment) owned.add(S.equipment[s]);
  
  const items = EQUIPMENT_DB.filter(e => 
    accSlots.includes(e.slot) && ['rare','unique','epic'].includes(e.tier) && !owned.has(e.id) && e.lv <= (S.lv||1)+5
  ).slice(0, 8);
  
  let html = `<div class="shop-container">
    <div class="shop-header"><span>💍 歌兰蒂斯首饰店</span><span style="color:var(--gold);font-size:12px;">💰 ${S.gold}G</span></div>
    <div class="shop-npc-desc">「${NPCS.grandis.desc}」</div>`;
  
  if(items.length > 0) {
    html += `<div class="shop-grid">`;
    items.forEach(item => {
      const ti = TIERS[item.tier];
      const price = { rare:500, unique:2000, epic:8000 }[item.tier] || 500;
      html += `<div class="shop-item" onclick="buyGrandisItem('${item.id}',${price})">
        <span class="shop-item-icon">${getItemIcon(item)}</span>
        <div class="shop-item-info">
          <div class="shop-item-name" style="color:${ti.color};">[${ti.name}] ${item.name}</div>
          <div class="shop-item-desc">Lv.${item.lv} · ${item.desc?.split('。')[0]||''}</div>
        </div>
        <span class="shop-item-price">${price}G</span>
      </div>`;
    });
    html += `</div>`;
  } else {
    html += `<div style="color:var(--dim);text-align:center;padding:20px;">你已经拥有当前等级可用的全部首饰了</div>`;
  }
  
  html += `<button class="continue-btn" onclick="backToRegion()">← 返回城镇</button>
          <button class="continue-btn" onclick="goHome()" style="margin-top:4px;font-size:11px;">🏠 返回大厅</button></div>`;
  main.innerHTML = html;
}

export function buyGrandisItem(itemId, price) {
  if(S.gold < price) { toast('金币不足！'); return; }
  if(S.inventory.length >= 128) { toast('背包已满！'); return; }
  S.gold -= price;
  S.ownedEquipIds = S.ownedEquipIds || [];
  S.ownedEquipIds.push(itemId);
  S.inventory.push({ id: itemId, type:'equip' });
  const item = getEquipById(itemId);
  showDropNotify(item || { name:itemId, tier:'rare' });
  toast(`✨ 购得首饰：${item?.name||itemId}！`, 2500);
  save(); renderGrandisShop();
}

// --- 诺顿·炼金商店 ---
export function renderNortonShop() {
  const main = document.getElementById('main');
  const potions = [
    { id:'norton_atk', name:'攻击强化药剂', desc:'下一场战斗攻击力+50%', icon:'⚔️', price:300, effect:'atkBuff' },
    { id:'norton_def', name:'防御强化药剂', desc:'下一场战斗防御力+50%', icon:'🛡️', price:300, effect:'defBuff' },
    { id:'norton_spd', name:'速度强化药剂', desc:'下一场战斗速度+50%', icon:'💨', price:300, effect:'spdBuff' },
    { id:'hp_potion_l', name:'高级HP药剂', desc:'恢复250HP', icon:'🧪', price:40 },
    { id:'mp_potion_s', name:'技能药剂', desc:'恢复30技能值', icon:'💠', price:8 },
    { id:'antidote', name:'解毒药', desc:'治疗中毒', icon:'🌿', price:12 },
  ];
  
  let html = `<div class="shop-container">
    <div class="shop-header"><span>⚗️ 诺顿炼金工坊</span><span style="color:var(--gold);font-size:12px;">💰 ${S.gold}G</span></div>
    <div class="shop-npc-desc">「${NPCS.norton.desc}」</div>
    <div class="shop-grid">`;
  
  potions.forEach(p => {
    html += `<div class="shop-item" onclick="buyNortonItem('${p.id}',${p.price},'${p.effect||''}')">
      <span class="shop-item-icon">${p.icon}</span>
      <div class="shop-item-info">
        <div class="shop-item-name">${p.name}</div>
        <div class="shop-item-desc">${p.desc}</div>
      </div>
      <span class="shop-item-price">${p.price}G</span>
    </div>`;
  });
  
  html += `</div>
    <button class="continue-btn" onclick="backToRegion()">← 返回城镇</button>
          <button class="continue-btn" onclick="goHome()" style="margin-top:4px;font-size:11px;">🏠 返回大厅</button></div>`;
  main.innerHTML = html;
}

// --- 索西雅天空酒馆 ---
export function renderSosiaShop() {
  const main = document.getElementById('main');
  const items = [
    { id:'hp_potion_m', name:'中级HP药剂', desc:'恢复100HP', icon:'🧪', price:12 },
    { id:'hp_potion_l', name:'高级HP药剂', desc:'恢复250HP', icon:'🧪', price:35 },
    { id:'mp_potion_s', name:'技能药剂', desc:'恢复30技能值', icon:'💠', price:6 },
    { id:'sosia_wine', name:'精灵蜜酒', desc:'恢复50HP+20MP，一次性', icon:'🍷', price:80 },
  ];
  
  let html = `<div class="shop-container">
    <div class="shop-header"><span>🍷 天空酒馆</span><span style="color:var(--gold);font-size:12px;">💰 ${S.gold}G</span></div>
    <div class="shop-npc-desc">「${NPCS.sosia.desc}」</div>
    <div class="shop-npc-desc" style="font-size:11px;color:var(--dim);margin-top:4px;">✨ 在此购物可恢复20HP（酒馆热汤）</div>
    <div class="shop-grid">`;

  items.forEach(p => {
    html += `<div class="shop-item" onclick="buySosiaItem('${p.id}',${p.price})">
      <span class="shop-item-icon">${p.icon}</span>
      <div class="shop-item-info">
        <div class="shop-item-name">${p.name}</div>
        <div class="shop-item-desc">${p.desc}</div>
      </div>
      <span class="shop-item-price">${p.price}G</span>
    </div>`;
  });

  html += `</div>
    <button class="continue-btn" onclick="backToRegion()">← 返回城镇</button>
    <button class="continue-btn" onclick="goHome()" style="margin-top:4px;font-size:11px;">🏠 返回大厅</button></div>`;
  main.innerHTML = html;
  // 酒馆休息效果
  S.hp = Math.min(S.maxHp, S.hp + 20);
  save();
}

export function buySosiaItem(itemId, price) {
  if(S.gold < price) { toast('金币不足！'); return; }
  if(S.inventory.length >= 128) { toast('背包已满！'); return; }
  S.gold -= price;
  S.inventory.push({ id:itemId, type:'consumable' });
  save();
  toast('购买成功！');
}

export function buyNortonItem(itemId, price, effect) {
  if(S.gold < price) { toast('金币不足！'); return; }
  if(S.inventory.length >= 128) { toast('背包已满！'); return; }
  S.gold -= price;
  
  if(effect) {
    // Buff药剂：直接应用效果
    S._nortonBuff = S._nortonBuff || {};
    S._nortonBuff[effect] = true;
    if(effect === 'atkBuff') { S.atk = Math.floor(S.atk * 1.5); toast('⚔️ 攻击力+50%！下一场战斗有效', 2500); }
    else if(effect === 'defBuff') { S.def = Math.floor(S.def * 1.5); toast('🛡️ 防御力+50%！下一场战斗有效', 2500); }
    else if(effect === 'spdBuff') { S.spd = Math.floor(S.spd * 1.5); toast('💨 速度+50%！下一场战斗有效', 2500); }
  } else {
    // 普通消耗品
    if(itemId === 'hp_potion_l') S.inventory.push({ id:'hp_potion_l', type:'consumable' });
    else if(itemId === 'mp_potion_s') S.inventory.push({ id:'mp_potion_s', type:'consumable' });
    else S.inventory.push({ id:itemId, type:'consumable' });
    toast(`✨ 购得药剂！`, 1500);
  }
  save(); renderNortonShop();
}

// --- 流浪商人购买 ---
export function buyMerchantItem(itemId, price, key) {
  if(S.gold < price) { toast('金币不足！'); return; }
  if(S.inventory.length >= 128) { toast('背包已满！'); return; }
  S.gold -= price;
  const item = S._merchantItems?.[key];
  if(!item) return;
  S.ownedEquipIds = S.ownedEquipIds || [];
  S.ownedEquipIds.push(item.id);
  S.inventory.push({ id: item.id, type:'equip' });
  showDropNotify(item);
  toast(`✨ 购得 [史诗] ${item.name}！`, 2500);
  save();
  dismissMerchant();
}

// --- 背包界面 ---
export function showInventory() {
  const main = document.getElementById('main');
  if(!S.mp) S.mp = 50;
  const stats = getEquipStats();
  const effAtk = S.atk + stats.bonusAtk + stats.bonusStr;
  const effDef = S.def + stats.bonusDef;
  const effSpd = S.spd + stats.bonusSpd;
  const totalInt = stats.bonusInt;

  // 角色立绘 + 属性
  const classImg2 = S.cls ? `assets/class_${S.cls}.png` : '';
  let html = `<div class="inv-overlay">
    <div class="inv-header">
      <span class="inv-header-title">🎒 背包 & 装备</span>
      <button class="inv-close" onclick="closeInventory()">✕</button>
    </div>`;
  html += `<div class="inv-portrait-section">
    <img class="inv-portrait" src="${classImg2}" onerror="this.style.display='none'" alt="portrait">
    <div class="inv-portrait-info">
      <div class="inv-portrait-name">${S.name} <span style="color:var(--dim);font-weight:400;">Lv.${S.lv}</span></div>
      <div class="inv-portrait-stat">⚔️ <span class="inv-portrait-stat-val">${effAtk}</span>${stats.bonusAtk+stats.bonusStr>0?' <span class="inv-portrait-stat-bonus">(+'+(stats.bonusAtk+stats.bonusStr)+')</span>':''}</div>
      <div class="inv-portrait-stat">🛡️ <span class="inv-portrait-stat-val">${effDef}</span>${stats.bonusDef>0?' <span class="inv-portrait-stat-bonus">(+'+stats.bonusDef+')</span>':''}</div>
      <div class="inv-portrait-stat">💨 <span class="inv-portrait-stat-val">${effSpd}</span>${stats.bonusSpd>0?' <span class="inv-portrait-stat-bonus">(+'+stats.bonusSpd+')</span>':''}</div>
      ${totalInt>0?`<div class="inv-portrait-stat">🔮 <span class="inv-portrait-stat-val">${totalInt}</span><span class="inv-portrait-stat-bonus">(+${totalInt})</span></div>`:''}
      <div class="inv-portrait-stat" style="font-size:10px;">❤️ ${S.hp}/${S.maxHp} ⚡${S.fatigue}/${S.maxFatigue}</div>
    </div>
  </div>`;

  html += `<div class="inv-layout">`;

  // 装备槽位定义
  const slotDefs = [
    { slot:'helm',     name:'头盔', icon:'🪖', row:0, col:1 },
    { slot:'amulet',   name:'项链', icon:'📿', row:1, col:0 },
    { slot:'weapon',   name:'武器', icon:'⚔️', row:1, col:2 },
    { slot:'bracelet', name:'手镯', icon:'⭕', row:2, col:0 },
    { slot:'armor',    name:'上衣', icon:'🛡️', row:2, col:1 },
    { slot:'ring',     name:'戒指', icon:'💍', row:2, col:2 },
    { slot:'belt',     name:'腰带', icon:'🔗', row:3, col:1 },
    { slot:'pants',    name:'下装', icon:'👖', row:4, col:1 },
    { slot:'boots',    name:'靴子', icon:'👢', row:5, col:1 },
  ];

  // 左侧纸娃娃
  html += `<div class="paperdoll">`;
  slotDefs.forEach(sd => {
    const eqId = S.equipment ? S.equipment[sd.slot] : null;
    const item = eqId ? getEquipById(eqId) : null;
    if(item) {
      const tierInfo = TIERS[item.tier];
      const icon = getItemIcon(item);
      const glowClass = item.tier === 'rare' ? ' glow-rare' : item.tier === 'unique' ? ' glow-unique' : item.tier === 'epic' ? ' glow-epic' : '';
      const mismatch = isWeaponMismatch(item);
      html += `<div class="equip-slot has-item${glowClass}${mismatch?' weapon-mismatch':''}" onclick="unequipSlot('${sd.slot}')" onmouseenter="cancelCloseDetail();showEquipDetailFromSlot('${sd.slot}',event)">
        <div class="equipped-item" style="color:${tierInfo.color};border:1px solid ${tierInfo.color}40;background:${tierInfo.color}10;box-shadow:0 0 8px ${tierInfo.color}30">
          <span class="equip-icon">${icon}</span>
          <span class="equip-label">${item.name}${mismatch?' <span style="color:var(--red);font-size:9px;">⚠️</span>':''}</span>
        </div>
      </div>`;
    } else {
      html += `<div class="equip-slot" title="${sd.name}（空）">
        <span class="slot-icon" style="filter:grayscale(0.6)">${sd.icon}</span>
        <span class="slot-label">${sd.name}</span>
      </div>`;
    }
  });
  html += `</div>`;

  // 右侧背包网格
  const inv = S.inventory || [];
  html += `<div class="inv-grid-panel">
    <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:6px;">
      <span style="font-size:10px;color:var(--dim);">背包 ${inv.filter(Boolean).length}/128</span>
      <button class="inv-sort-btn" onclick="sortInventory();event.stopPropagation();">📦 整理</button>
    </div>
    <div class="inv-grid-scroll">
    <div class="inv-grid">`;
  for(let i = 0; i < 128; i++) {
    const invItem = inv[i];
    if(invItem) {
      const isEquip = invItem.type === 'equip';
      const item = isEquip ? getEquipById(invItem.id) : (CONSUMABLES[invItem.id] || null);
      if(item) {
        const color = isEquip ? (TIERS[item.tier]?.color || '#aaa') : (item.color || '#aaa');
        const mismatch = isEquip && isWeaponMismatch(item);
        const qty = (invItem.qty && invItem.qty > 1) ? invItem.qty : 0;
        html += `<div class="inv-slot has-item${mismatch?' weapon-mismatch-grid':''}" onclick="invSlotClick(${i})" onmouseenter="cancelCloseDetail();showEquipDetailHover(${i},event)">
          <span class="inv-icon">${getItemIcon(item)}</span>
          <span class="item-name" style="color:${mismatch?'var(--red)':color}">${item.name}${mismatch?' ⚠️':''}</span>
          ${qty > 0 ? `<span class="inv-qty">${qty}</span>` : ''}
          ${(invItem.affixes && invItem.affixes.length > 0) ? `<span style="position:absolute;top:1px;right:1px;background:var(--gold);color:#000;font-size:7px;border-radius:2px;padding:0 2px;font-weight:bold;line-height:1.2;">${invItem.affixes.length}</span>` : ''}
        </div>`;
      } else {
        html += `<div class="inv-slot"></div>`;
      }
    } else {
      html += `<div class="inv-slot"></div>`;
    }
  }
  html += `</div></div>`;

  // 属性面板
  html += `<div class="inv-stats">
    <div class="inv-stats-row">
      <div class="inv-stat">⚔️攻击 <span class="inv-stat-val">${effAtk}</span>${stats.bonusAtk+stats.bonusStr>0?`<span class="inv-stat-bonus">(+${stats.bonusAtk+stats.bonusStr})</span>`:''}</div>
      <div class="inv-stat">🛡️防御 <span class="inv-stat-val">${effDef}</span>${stats.bonusDef>0?`<span class="inv-stat-bonus">(+${stats.bonusDef})</span>`:''}</div>
      <div class="inv-stat">💨速度 <span class="inv-stat-val">${effSpd}</span>${stats.bonusSpd>0?`<span class="inv-stat-bonus">(+${stats.bonusSpd})</span>`:''}</div>
      ${totalInt>0?`<div class="inv-stat">🔮智力 <span class="inv-stat-val">${totalInt}</span><span class="inv-stat-bonus">(+${totalInt})</span></div>`:''}
    </div>`;

  // 状态
  if(S.statusEffects && Object.keys(S.statusEffects).length > 0) {
    html += `<div style="margin-top:6px;">`;
    if(S.statusEffects.poison) html += '<span style="color:#8a2;font-size:10px;">☠ 中毒 </span>';
    if(S.statusEffects.freeze) html += '<span style="color:#5af;font-size:10px;">❄ 冰冻 </span>';
    if(S.statusEffects.curse) html += '<span style="color:#b7f;font-size:10px;">◈ 诅咒 </span>';
    html += `</div>`;
  }

  // 被动技能
  if(S.cls) {
    const c = CLASSES[S.cls];
    html += `<div style="margin-top:6px;font-size:10px;color:var(--blue);">✦ ${c.passive}</div>`;
  }

  html += `</div>`; // inv-stats
  html += `</div>`; // inv-grid-panel
  html += `</div>`; // inv-layout
  html += `</div>`; // inv-overlay

  // 返回按钮
  html += `<button class="continue-btn" onclick="closeInventory()">关闭背包</button>`;
  main.innerHTML = html;
}


// 查找物品的词条
function findInvAffixes(itemId) {
  const inv = window.S.inventory || [];
  for(let i = 0; i < inv.length; i++) {
    if(inv[i] && inv[i].id === itemId && inv[i].affixes) return inv[i].affixes;
  }
  return [];
}

// --- 装备详情（hover）---
export function showEquipDetailHover(idx, e) {
  if(!S.inventory || idx >= S.inventory.length) return;
  const invItem = S.inventory[idx];
  if(!invItem || invItem.type !== 'equip') return;
  const item = getEquipById(invItem.id);
  if(!item) return;
  showEquipDetail(item, idx, e);
}

// --- 装备详情（Popup）---
export function showEquipDetail(item, sourceIdx, e) {
  if(window.__detailCloseTimer) clearTimeout(window.__detailCloseTimer);
  window.closeEquipDetail();
  const tierInfo = TIERS[item.tier];
  const isEquipped = S.equipment && Object.values(S.equipment).includes(item.id);
  const icon = getItemIcon(item);
  const rect = e ? e.currentTarget.getBoundingClientRect() : null;
  const top = rect ? `${rect.bottom + 8}px` : '50%';
  const left = rect ? `${Math.min(rect.left, window.innerWidth - 370)}px` : '50%';
  const transform = rect ? 'none' : 'translate(-50%, -50%)';

  let html = `<div class="equip-detail-overlay" style="background:transparent;pointer-events:none;">
    <div class="equip-detail-card" style="border-color:${tierInfo.color}44;position:fixed;top:${top};left:${left};max-width:340px;transform:${transform};pointer-events:auto;animation:none;" onmouseenter="cancelCloseDetail()" onmouseleave="scheduleCloseDetail()">
      <div class="equip-detail-header">
        <span class="equip-detail-icon" style="color:${tierInfo.color}">${icon}</span>
        <div class="equip-detail-name" style="color:${tierInfo.color}">${item.name}</div>
        <div class="equip-detail-tier" style="color:${tierInfo.color}">[${tierInfo.name}] Lv.${item.lv}</div>
      </div>
      <div class="equip-detail-body">`;

  if(item.atk||item.def||item.str||item.int||item.spd) {
    html += `<div class="equip-detail-stats">`;
    if(item.atk) html += `<div class="equip-detail-stat"><div class="equip-detail-stat-label">⚔️</div><div class="equip-detail-stat-val">+${item.atk}</div></div>`;
    if(item.def) html += `<div class="equip-detail-stat"><div class="equip-detail-stat-label">🛡️</div><div class="equip-detail-stat-val">+${item.def}</div></div>`;
    if(item.str) html += `<div class="equip-detail-stat"><div class="equip-detail-stat-label">💪</div><div class="equip-detail-stat-val">+${item.str}</div></div>`;
    if(item.int) html += `<div class="equip-detail-stat"><div class="equip-detail-stat-label">🔮</div><div class="equip-detail-stat-val">+${item.int}</div></div>`;
    if(item.spd) html += `<div class="equip-detail-stat"><div class="equip-detail-stat-label">💨</div><div class="equip-detail-stat-val">+${item.spd}</div></div>`;
    html += `</div>`;
  }

  html += `<div class="equip-detail-effect"><div class="eff-label">📋 ${item.desc || '一件普通的装备。'}</div></div>`;

  if(item.onAttack) {
    html += `<div class="equip-detail-effect" style="border-color:${tierInfo.color}44;">
      <div class="eff-label" style="color:${tierInfo.color};">✨ 特殊效果：【${item.onAttack}】</div>
      ${item.atkEffect ? `<span style="color:var(--dim);font-size:11px;">${getAtkEffectDesc(item.atkEffect)}</span>` : ''}
    </div>`;
  }

  if(item.quote) {
    html += `<div class="equip-detail-quote">${item.quote}</div>`;
  }

  if(isWeaponMismatch(item)) {
    html += `<div style="color:var(--red);font-size:11px;padding:10px 0 4px;border-top:1px solid rgba(192,57,43,0.2);margin-top:4px;">
      ⚠️ 武器类型不匹配：攻击-30% | 防御-30% | 速度-30%
    </div>`;
  }

  html += `</div></div></div>`;
  document.body.insertAdjacentHTML('beforeend', html);
}

// --- 装备详情（从装备槽位）---
export function showEquipDetailFromSlot(slot, e) {
  if(!S.equipment || !S.equipment[slot]) return;
  const item = getEquipById(S.equipment[slot]);
  if(!item) return;
  if(window.__detailCloseTimer) clearTimeout(window.__detailCloseTimer);
  window.closeEquipDetail();
  const tierInfo = TIERS[item.tier];
  const icon = getItemIcon(item);
  const rect = e ? e.currentTarget.getBoundingClientRect() : null;
  const top = rect ? `${rect.top - 240}px` : '50%';
  const left = rect ? `${Math.min(rect.left, window.innerWidth - 350)}px` : '50%';

  let html = `<div class="equip-detail-overlay" style="background:transparent;pointer-events:none;">
    <div class="equip-detail-card" style="border-color:${tierInfo.color}44;position:fixed;top:${top};left:${left};max-width:340px;transform:${rect?'none':'translate(-50%,-50%)'};pointer-events:auto;animation:none;" onmouseenter="cancelCloseDetail()" onmouseleave="scheduleCloseDetail()">
      <div class="equip-detail-header">
        <span class="equip-detail-icon" style="color:${tierInfo.color}">${icon}</span>
        <div class="equip-detail-name" style="color:${tierInfo.color}">${item.name}</div>
        <div class="equip-detail-tier" style="color:${tierInfo.color}">[${tierInfo.name}] Lv.${item.lv}</div>
      </div>
      <div class="equip-detail-body">`;

  if(item.atk||item.def||item.str||item.int||item.spd) {
    html += `<div class="equip-detail-stats">`;
    if(item.atk) html += `<div class="equip-detail-stat"><div class="equip-detail-stat-label">⚔️</div><div class="equip-detail-stat-val">+${item.atk}</div></div>`;
    if(item.def) html += `<div class="equip-detail-stat"><div class="equip-detail-stat-label">🛡️</div><div class="equip-detail-stat-val">+${item.def}</div></div>`;
    if(item.str) html += `<div class="equip-detail-stat"><div class="equip-detail-stat-label">💪</div><div class="equip-detail-stat-val">+${item.str}</div></div>`;
    if(item.int) html += `<div class="equip-detail-stat"><div class="equip-detail-stat-label">🔮</div><div class="equip-detail-stat-val">+${item.int}</div></div>`;
    if(item.spd) html += `<div class="equip-detail-stat"><div class="equip-detail-stat-label">💨</div><div class="equip-detail-stat-val">+${item.spd}</div></div>`;
    html += `</div>`;
  }

  html += `<div class="equip-detail-effect"><div class="eff-label">📋 ${item.desc || '一件普通的装备。'}</div></div>`;

  
  // 词条展示（装备槽位）
  const slotAffixes = findInvAffixes(item.id);
  if(slotAffixes && slotAffixes.length > 0) {
    html += '<div class="equip-detail-effect" style="border-color:var(--gold)44;"><div class="eff-label" style="color:var(--gold);font-size:11px;">⚡ 词条</div>';
    slotAffixes.forEach(af => {
      const tc = af.tier === 'epic' ? 'var(--orange)' : af.tier === 'rare' ? 'var(--gold)' : af.tier === 'advanced' ? '#8cf' : '#aaa';
      html += '<div style="font-size:10px;color:'+tc+';padding:2px 0;">'+af.name+'：'+af.desc+'</div>';
    });
    html += '</div>';
  }
if(item.onAttack) {
    html += `<div class="equip-detail-effect" style="border-color:${tierInfo.color}44;">
      <div class="eff-label" style="color:${tierInfo.color};">✨ 特殊效果：【${item.onAttack}】</div>
      ${item.atkEffect ? `<span style="color:var(--dim);font-size:11px;">${getAtkEffectDesc(item.atkEffect)}</span>` : ''}
    </div>`;
  }

  if(item.quote) {
    html += `<div class="equip-detail-quote">${item.quote}</div>`;
  }

  if(isWeaponMismatch(item)) {
    html += `<div style="color:var(--red);font-size:11px;padding:8px 0 4px;border-top:1px solid rgba(192,57,43,0.2);margin-top:4px;">
      ⚠️ 武器类型不匹配：攻击-30% | 防御-30% | 速度-30%
    </div>`;
  }

  html += `<div class="equip-detail-btns" style="padding-bottom:14px;">
    <button class="equip-detail-btn primary" onclick="unequipSlot('${slot}')">🔓 卸下</button>
    <button class="equip-detail-btn danger" onclick="if(confirm('确定摧毁【${item.name}】？')){delete S.equipment['${slot}'];closeEquipDetail();showInventory();save();}">🗑</button>
  </div>`;

  html += `</div></div></div>`;
  document.body.insertAdjacentHTML('beforeend', html);
}

// --- 装备/卸下 ---
export function equipItem(idx) {
  if(!S.inventory || idx >= S.inventory.length) return;
  const invItem = S.inventory[idx];
  if(invItem.type !== 'equip') { toast('该物品无法装备'); return; }
  const item = getEquipById(invItem.id);
  if(!item) return;
  if(!S.equipment) S.equipment = {};
  const oldItem = S.equipment[item.slot];
  S.equipment[item.slot] = invItem.id;
  S.inventory.splice(idx, 1);
  if(oldItem) S.inventory.push({ id: oldItem, type: 'equip' });
  let msg = `装备了【${item.name}】`;
  if(isWeaponMismatch(item)) {
    const clsWT = CLASSES[S.cls]?.weaponType;
    const wtNames = {blade:'刀剑', gun:'枪炮', holy:'圣器', fist:'拳套'};
    msg += ` ⚠️ 武器类型不匹配（需要${wtNames[clsWT]||clsWT}），属性减半！`;
  }
  toast(msg);
  save();
}

export function unequipSlot(slot) {
  if(!S.equipment || !S.equipment[slot]) return;
  const itemId = S.equipment[slot];
  const item = getEquipById(itemId);
  S.inventory.push({ id: itemId, type: 'equip' });
  delete S.equipment[slot];
  toast(`卸下了【${item ? item.name : '装备'}】`);
  save();
  window.closeEquipDetail();
  showInventory(); // 刷新背包显示
}

// --- 物品系统 ---
export function addItem(id) {
  if(!S.inventory) S.inventory = [];
  // 判断是消耗品还是装备
  if(CONSUMABLES[id]) {
    S.inventory.push({ id, type: 'consumable' });
  } else {
    S.inventory.push({ id, type: 'equip' });
  }
}

export function removeItem(id) {
  if(!S.inventory) return;
  const idx = S.inventory.findIndex(i=>i.id===id);
  if(idx !== -1) S.inventory.splice(idx, 1);
}

// ========== 分解/出售/强化 ==========
export function getDismantleGold(tier, enhanceLv) {
  const base = { common:10, fine:30, rare:80, unique:200, epic:500 }[tier] || 10;
  return base + enhanceLv * 20;
}

export function getSellPrice(item) {
  const lv = item.lv || 1;
  const tierMult = { common:1, fine:2, rare:4, unique:8, epic:20 }[item.tier] || 1;
  return Math.floor(lv * 3 * tierMult + (S.enhanceLevels?.[item.id]||0) * 30);
}

export function doSellEquip(equipId, source, idxOrSlot) {
  const item = getEquipById(equipId);
  if(!item) return;
  const price = getSellPrice(item);
  if(source === 'inventory') {
    S.inventory.splice(idxOrSlot, 1);
  } else {
    delete S.equipment[idxOrSlot];
  }
  S.gold += price;
  toast(`💰 卖出 [${TIERS[item.tier].name}] ${item.name}，获得 ${price}G`, 2000);
  save(); renderBlacksmithShop();
}

export function doSellConsumable(idx, count) {
  if(idx >= S.inventory.length) return;
  const inv = S.inventory[idx];
  if(!inv || inv.type === 'equip') return;
  const con = CONSUMABLES[inv.id];
  if(!con) return;
  const price = Math.floor(con.price * 0.5);
  // Remove one stack
  S.inventory.splice(idx, 1);
  S.gold += price;
  toast(`💰 卖出 ${con.name}，获得 ${price}G`, 2000);
  save(); renderSeraShop();
}

export function doEnhance(equipId) {
  const item = getEquipById(equipId);
  if(!item) return;
  if(!S.enhanceLevels) S.enhanceLevels = {};
  const curLv = S.enhanceLevels[equipId] || 0;
  const nextLv = curLv + 1;
  if(nextLv > 10) { toast('已达到最大强化等级！'); return; }
  const eData = ENHANCE_TABLE.find(e => e.lv === nextLv);
  if(!eData) { toast('强化数据错误'); return; }
  if(S.gold < eData.cost) { toast(`金币不足！需要 ${eData.cost}G`); return; }
  S.gold -= eData.cost;

  // 管理后台自定义成功率
  const adminCfg = window.__adminCfg || {};
  const adminRate = adminCfg.enhanceRates ? adminCfg.enhanceRates[nextLv - 1] : undefined;
  const effectiveRate = (adminRate !== undefined) ? adminRate : eData.rate;

  const roll = Math.random();
  if(roll < effectiveRate) {
    // 成功
    S.enhanceLevels[equipId] = nextLv;
    toast(`🎉 强化成功！【${item.name}】→ +${nextLv}`);
  } else {
    // 失败
    const newLv = Math.max(0, curLv + eData.penalty);
    S.enhanceLevels[equipId] = newLv;
    const msg = eData.penalty === 0 ? '强化失败，但装备没有受损' :
                eData.penalty === -5 ? `💔 强化大失败！【${item.name}】归零！` :
                `⚠️ 强化失败！【${item.name}】→ +${newLv}`;
    toast(msg);
  }
  save(); renderBlacksmithShop();
}

export function doDismantleById(equipId, source, identifier) {
  const item = getEquipById(equipId);
  if(!item) return;
  doDismantle(item, equipId, source, identifier);
}

export function doDismantle(item, equipId, source, identifier) {
  const enhanceLv = (S.enhanceLevels||{})[equipId] || 0;
  const gold = getDismantleGold(item.tier, enhanceLv);
  S.gold += gold;
  if(source === 'equipped') {
    delete S.equipment[identifier];
  } else {
    S.inventory.splice(parseInt(identifier), 1);
  }
  delete (S.enhanceLevels||{})[equipId];
  toast(`分解了【${item.name}】+${enhanceLv}，获得 ${gold}G`);
  save(); renderBlacksmithShop();
}

export function doKiriEnhance(equipId, targetLv) {
  const cost = 500 + targetLv * 300;
  if(S.gold < cost) { toast(`金币不足！需要 ${cost}G`); return; }
  S.gold -= cost;
  const rate = Math.max(0.1, 1.0 - (targetLv - 1) * 0.08);
  const roll = Math.random();
  if(roll < rate) {
    S.enhanceLevels[equipId] = targetLv;
    toast(`✨ 强化成功！+${targetLv}`, 2000);
  } else {
    // 失败：+10以上可能碎装备
    if(targetLv > 10 && Math.random() < 0.3) {
      // 装备碎裂！
      const item = getEquipById(equipId);
      for(const slot in S.equipment) { if(S.equipment[slot] === equipId) { delete S.equipment[slot]; break; } }
      removeEquipFromInventory(equipId);
      delete S.enhanceLevels[equipId];
      toast(`💔 强化失败！${item?.name||'装备'}碎了……`, 3000);
    } else {
      // 降级
      const curLv = S.enhanceLevels[equipId] || 0;
      S.enhanceLevels[equipId] = Math.max(0, curLv - 1);
      toast(`⚠️ 强化失败！降为 +${S.enhanceLevels[equipId]}`, 2000);
    }
  }
  save(); renderKiriShop();
}

export function removeEquipFromInventory(equipId) {
  if(!S.inventory) return;
  const idx = S.inventory.findIndex(i => i && i.id === equipId);
  if(idx >= 0) S.inventory.splice(idx, 1);
}

export function rerollAffix(invIdx, cost) {
  if(!S.inventory || !S.inventory[invIdx]) return;
  const cc = S.chaosCrystals || 0;
  if(cc < cost) { toast('💎 混沌结晶不足！需要'+cost+'个', 2000); return; }
  S.chaosCrystals -= cost;
  const inv = S.inventory[invIdx];
  const eq = window.ALL_EQUIPMENT.find(e => e.id === inv.id);
  if(!inv.affixes || inv.affixes.length === 0) return;

  // 移除一个随机旧词条，roll一个新词条
  const oldIdx = Math.floor(Math.random() * inv.affixes.length);
  const oldAf = inv.affixes[oldIdx];

  // 从对应池roll新词条
  const tier = eq.tier;
  let pool = window.AFFIX_POOLS.common;
  if(tier === 'epic' && Math.random() < 0.15) pool = window.AFFIX_POOLS.epic;
  else if((tier === 'unique' || tier === 'epic') && Math.random() < 0.25) pool = window.AFFIX_POOLS.advanced;

  const newAf = pool[Math.floor(Math.random() * pool.length)];
  inv.affixes[oldIdx] = newAf;

  save();
  toast('⚡ 词条替换：'+oldAf.name+' → '+newAf.name+'！', 3000);
  renderNortonShop(); renderStatusbar();
}

// ========== 骰子游戏 / 商人 ==========
export function playDiceGame(guess) {
  const cost = S._merchantDiceCost || 500;
  if(S.gold < cost) { toast(`金币不足！需要 ${cost}G`); return; }
  S.gold -= cost;

  const roll = Math.floor(Math.random() * 6) + 1;
  const win = roll === guess;
  save();

  const main = document.getElementById('main');
  const existing = main.querySelector('.dice-result');
  if(existing) existing.remove();

  let html = `<div class="dice-result story-box" style="border-color:var(--pink);margin-top:8px;">
    <strong style="color:var(--pink);">🎲 你猜${guess}点，骰子开出：${roll}点！</strong><br>`;

  if(win) {
    html += `<span style="color:var(--green);">🎉 猜中了！</span> 选一件装备，只需<span style="color:var(--gold);">1金币</span>！`;
    if(S._merchantItems) {
      Object.entries(S._merchantItems).forEach(([k, item]) => {
        html += `<div class="shop-item" style="border:1px dashed var(--gold);margin:4px 0;padding:6px;cursor:pointer;" onclick="window.buyMerchantItem('${item.id}',1,'${k}')">
          <span style="color:var(--gold);">👑 ${item.name}</span> — <span style="color:var(--green);">💰 1G！</span>
        </div>`;
      });
    }
  } else {
    html += `<span style="color:var(--red);">猜错了……</span> 损失了 ${cost} 金币。商品维持原价。`;
  }
  html += `</div>`;
  main.insertAdjacentHTML('beforeend', html);
}

export function dismissMerchant() {
  S._merchantItems = {};
  const main = document.getElementById('main');
  const el = main.querySelector('.dice-result');
  if(el) el.remove();
  // 移除商人面板（最后插入的 story-box 或 dice-result）
  const boxes = main.querySelectorAll('.story-box');
  for(let i = boxes.length - 1; i >= 0; i--) {
    if(boxes[i].textContent.includes('流浪商人')) {
      boxes[i].remove();
      break;
    }
  }
}

// ========== 背包关闭 ==========
export function closeInventory() {
  if(S.combat) {
    window.renderCombat();
  } else if(S._dungeonRooms && S._dungeonRooms.length > 0) {
    // 在地下城中
    const index = S._dungeonRoomIndex || 0;
    const room = S._dungeonRooms[index];
    const main = document.getElementById('main');
    if(room && room.cleared) {
      // ★ 已清房间：纯渲染，不调 renderDungeonRoom（避免重复奖励/状态错乱）
      main.innerHTML = `<div style="text-align:center;padding:40px 20px;"><div style="font-size:28px;margin-bottom:8px;">✓</div><div style="color:var(--dim);">该房间已清理完毕</div></div><button class="continue-btn" onclick="window.advanceDungeonRoom(${index})">继续探索 →</button>`;
    } else if(room) {
      // 未清房间：用 renderDungeonRoom 重绘（不调 goToDungeonRoom，避免重置房间索引）
      if(typeof window.renderDungeonRoom === 'function') window.renderDungeonRoom(room, index);
    }
  } else if(S.scene === 'lobby') {
    window.renderLobby();
  } else if(window.REGIONS && window.REGIONS.some(r => r.id === S.scene)) {
    window.renderRegionHub(S.scene);
  } else {
    window.renderScene();
  }
  window.renderStatusbar();
}

// ========== NPC 商店 ==========
export function openNPCShop(npcId) {
  const npc = NPCS[npcId];
  if(!npc) return;
  S._shopRegion = window.getCurrentRegionId() || 'forest';
  setTimeout(() => sfxNPCSpeak(npcId), 100);
  window.renderNPCDialogue(npcId);
}

export function openShopDirect(npcId) {
  if(npcId === 'sera') renderSeraShop();
  else if(npcId === 'jarmerchant') renderJarShop();
  else if(npcId === 'blacksmith') renderBlacksmithShop();
  else if(npcId === 'kiri') renderKiriShop();
  else if(npcId === 'grandis') renderGrandisShop();
  else if(npcId === 'norton') renderNortonShop();
  else if(npcId === 'sosia') renderSosiaShop();
}

export function openJar(jarId) {
  const jar = JARS.find(j => j.id === jarId);
  if(!jar) return;
  if(S.gold < jar.price) { toast('金币不足！'); return; }
  if(S.inventory.length >= 128) { toast('背包已满！'); return; }
  S.gold -= jar.price;

  // 根据罐子品级范围随机选装备
  const candidates = EQUIPMENT_DB.filter(e => jar.tiers.includes(e.tier) && e.lv <= (S.lv||1) + 5);
  if(candidates.length === 0) { toast('没有适合你等级的装备了！'); S.gold += jar.price; return; }
  const item = candidates[Math.floor(Math.random() * candidates.length)];

  const tierInfo = TIERS[item.tier];
  const resultEl = document.getElementById('jarResult');
  resultEl.innerHTML = `<div class="jar-shaking">🏺 摇晃中<span class="jar-dots">...</span></div>`;
  setTimeout(() => {
    // 玻璃碎裂声 + 财宝声
    sfxJarOpen();
    setTimeout(() => playSFX('sfx_treasure.mp3', 0.4), 200);

    resultEl.innerHTML = `<div style="animation:fadeIn 0.3s ease;">
      <span style="font-size:24px;">${jar.icon.split(' ')[0]}</span>
      <div style="color:${tierInfo.color};font-size:15px;font-weight:bold;margin:6px 0;">✨ [${tierInfo.name}] ${item.name}</div>
      <div style="color:var(--dim);font-size:10px;">${item.desc?.split('。')[0]||''}</div>
    </div>`;
    S.ownedEquipIds = S.ownedEquipIds || [];
    S.ownedEquipIds.push(item.id);
    S.inventory.push({ id: item.id, type:'equip' });
    showDropNotify(item);
    save(); renderJarShop();
    const header = document.querySelector('.shop-header span:last-child');
    if(header) header.textContent = `💰 ${S.gold}G`;
  }, 800);
}
